import { AlertColor } from "@mui/material";
import { SnackbarActionType } from "../constants";
import { ISnackbarAction } from "../types";

export function setSnackbar(snackDispatch: Function, message: string, severity: AlertColor): void {
    const action: ISnackbarAction = {
        type: SnackbarActionType.SET_SNACK,
        payload: {
            message, severity
        }
    }

    snackDispatch(action);
}